// This function takes a number and returns it as a string with commas as a thousand separators.
export const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const formatWithK = (num) => {
    if (num > 999999) {
        return (num / 1000000).toFixed(2) + 'M'
    }
    if (num > 999) {
        return (num / 1000).toFixed(2) + 'K'
    }

    if (typeof num === 'number') {
        return num.toFixed(2)
    }

    return num
}

export const calculatePercentage = (value, total) => {
    if (!value || !total) {
        return 0
    }
    return Math.round((value / total) * 100)
}